







































































import { Component, mixins, namespace, Prop } from 'nuxt-property-decorator'
import MixinProduct from '~/assets/mixins/product'
import { filterUrl } from '~/assets/filters/url'
import { CART_PATH } from '~/assets/config/path'
import ComponentFormButton from '~/components/form/button.vue'
import ComponentFormQuantityStepper from '~/components/form/quantity-stepper.vue'

const siteStore = namespace('site')

@Component({
  components: {
    ComponentFormButton,
    ComponentFormQuantityStepper,
  },
  name: 'ProductBuyButton',
})
export default class ComponentProductBuyButton extends mixins(MixinProduct) {
  @Prop({ type: String }) readonly size!: string
  @Prop({ type: Boolean, default: false })
  readonly canIncreaseQuantity!: boolean

  @siteStore.Getter('getOptionsCanChangeQuantity')
  readonly getOptionsCanChangeQuantity!: boolean

  private get classLarge() {
    return {
      [this.$style.large]: this.size === 'large',
      // Карточка товара в списках: одна высота 44px на всех устройствах,
      // без деления desktop/mobile — как у кнопки в блоке «Товар дня».
      [this.$style.medium]: this.size === 'medium',
    }
  }

  private async buy() {
    if (this.isInCart && this.aspectsForBuy.length === 0) {
      await this.$router.push(filterUrl(CART_PATH))
    } else {
      await this.toCart(1)
    }
  }
}
